import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Userprofile } from "../_models/Userprofile";
import { Observable } from "rxjs";
import { AddTutorDto, TutorProfile, UpdateTutorDto, UpdateTutorTableDto } from "../_models/Tutor";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class TutorService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Tutor/";
  private static readonly DISPLAY_TUTOR_LIST = "displaytutorlist";
  private static readonly TUTOR_LIST_LENGTH = "tutorlistlength";
  private static readonly UPDATE_TUTOR_LIST = "updatetutorlist";
  private static readonly RESET_TUTOR_LIST = "resettutorlist";
  private static readonly IS_ALLOWED_TO_EDIT_TUTOR = "iscurrentuserallowedtoedittutor";
  private static readonly UPDATE_TUTOR_INFO = "updatetutorinfo";
  private static readonly GET_TUTOR_USERPROFILE_BY_ID = "gettutorprofilebyid";
  private static readonly GROUP_TUTOR_COUNT = "getgrouptutorcount";
  private static readonly IS_TUTOR_HAS_ACCESS_ON_LEARNER = "istutorhasaccessonlearner";
  private static readonly DELETE_LIST_OF_TUTOR = "deletelistoftutor";
  private static readonly TUTOR_RECORD_LENGTH = "tutorrecordlength";
  private static readonly GET_PAGE_NUMBER = "getcurrentpagenumber";

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public addTutor$(addTutorDto: AddTutorDto): Observable<Userprofile> {
    return this.http.post<Userprofile>(
      `${this.baseUrl}${TutorService.path}`,
      addTutorDto
    );
  }

  public getTutorTableRecords$(
    pageNumber: number,
    isInitialLoad: boolean
  ): Observable<TutorProfile[]> {
    let params = new HttpParams().set("pageNumber", String(+pageNumber + 1));
    if (isInitialLoad)
      params = params.set("isInitialLoad", String(isInitialLoad));

    return this.http.get<TutorProfile[]>(
      this.baseUrl + TutorService.path + TutorService.DISPLAY_TUTOR_LIST,
      { params }
    );
  }

  public getTutorListLength$(): Observable<number> {
    return this.http.get<number>(
      this.baseUrl + TutorService.path + TutorService.TUTOR_LIST_LENGTH
    );
  }

  public getGroupTutorCount$(): Observable<string> {
    return this.http.get<string>(
      this.baseUrl + TutorService.path + TutorService.GROUP_TUTOR_COUNT
    );
  }

  public updateTutorTableRecords$(
    tableParameter: UpdateTutorTableDto
  ): Observable<boolean> {
    return this.http.put<boolean>(
      this.baseUrl + TutorService.path + TutorService.UPDATE_TUTOR_LIST,
      tableParameter
    );
  }

  public resetTutorTable$(): Observable<boolean> {
    return this.http.get<boolean>(
      this.baseUrl + TutorService.path + TutorService.RESET_TUTOR_LIST
    );
  }

  public isCurrentUserAllowedToEditTutor$(tutorId: number): Observable<boolean> {
    return this.http.get<boolean>(
      this.baseUrl + TutorService.path + TutorService.IS_ALLOWED_TO_EDIT_TUTOR + AppConstants.SLASH + 
      tutorId
    );
  }

  public updateTutor$(updateTutorDto: UpdateTutorDto): Observable<Userprofile> {
    return this.http.put<Userprofile>(
      this.baseUrl + TutorService.path + TutorService.UPDATE_TUTOR_INFO + AppConstants.SLASH +
      updateTutorDto.id,
      updateTutorDto
    );
  }

  public getTutorUserProfile$(id: number): Observable<Userprofile> {
    return this.http.get<Userprofile>(
      this.baseUrl + TutorService.path + TutorService.GET_TUTOR_USERPROFILE_BY_ID + AppConstants.SLASH + id
    );
  }

  public deleteListOfTutor$(ids: number[]): Observable<boolean> {
    return this.http.request<boolean>(
      AppConstants.DELETE,
      this.baseUrl + TutorService.path + TutorService.DELETE_LIST_OF_TUTOR,
      { body: ids }
    );
  }

  public isTutorHasAccessToLearner$(learnerId: number): Observable<boolean> {
    return this.http.get<boolean>(
      this.baseUrl + TutorService.path + TutorService.IS_TUTOR_HAS_ACCESS_ON_LEARNER + AppConstants.SLASH + learnerId
    );
  }

  public getActualTutorRecordLength$(): Observable<number> {
    return this.http.get<number>(
      this.baseUrl + TutorService.path + TutorService.TUTOR_RECORD_LENGTH
    )
  }

  public getCurrentPageNumber$(pageIndex: number): Observable<number> {
    let params = new HttpParams().set(AppConstants.PAGE_NUMBER, String(+pageIndex + 1));
    return this.http.get<number>(
      `${this.baseUrl}${TutorService.path}${TutorService.GET_PAGE_NUMBER}`,
      { params }
    );
  }
}
